module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/img-2-7078c064bce546e3fe8470a92a452367.png";